/* eslint-disable */
import AccessibilityNav from '../plugins/accessibilityNavPlugin';

export default function initAccessibilityNav() {
	document.querySelectorAll('.main-nav').forEach((nav) => {
		new AccessibilityNav(nav, '1200px');

		//this closes the search popup. Disabled as it's weird to close if you inadvertently hover over the menu
		// const searchPopupAPI = document.querySelector('body').MobileNav;

		// nav.querySelectorAll('.main-nav__link').forEach((link) => {
		// 	const parent = link.closest('.main-nav__item');
		// 	const drop = parent.querySelector('.main-nav-slide');

		// 	if (drop) {
		// 		link.addEventListener('mouseenter', () => {
		// 			if (searchPopupAPI) {
		// 				// searchPopupAPI.hide();
		// 			}
		// 		});
		// 	}
		// });

		document.querySelectorAll('.sub-menu').forEach((subMenu) => {
			subMenu.setAttribute('role', 'menu');
		});

		//mobile nav they are clicking on the current page. close the mobile nav
		document.querySelectorAll('.secondary-nav-mobile .main-nav__item.active a').forEach((item) => {
			item.addEventListener('click', (e) => {
				console.log("click");
				if (document.body.API) {
					document.body.API.hideMenu();
				}
			});
		});
	});
}
